import { createFileRoute, notFound } from "@tanstack/react-router";
import { MemoryBrowsePage } from "@/components/memory/memory-browse-page";
import { viewRouteSearch } from "@/components/views/views-data";
import { isReservedOwnerSegment } from "@/lib/reserved";
import { decodeEntityTypeParam } from "@/lib/url";

/**
 * A view attached to an entity type: `/{owner}/<type>/-/views/<key>`. The host
 * reads no query keys here, so the whole query string is the view's params
 * (`/acme/project/-/views/timeline?status=blocked`).
 */
export const Route = createFileRoute("/$owner/$entityType/-/views/$viewKey")({
	validateSearch: viewRouteSearch,
	beforeLoad: ({ params }) => {
		if (isReservedOwnerSegment(params.entityType)) throw notFound();
	},
	component: EntityTypeViewPage,
});

function EntityTypeViewPage() {
	const { owner, entityType, viewKey } = Route.useParams();
	return (
		<MemoryBrowsePage
			ownerSlug={owner}
			typeScope={decodeEntityTypeParam(entityType)}
			create={false}
			viewKey={viewKey}
		/>
	);
}
